/* unplugin-vue-components disabled */import { render } from "./UserSex.vue?vue&type=template&id=8c545a42&scoped=true"
import script from "./UserSex.vue?vue&type=script&lang=js"
export * from "./UserSex.vue?vue&type=script&lang=js"

import "./UserSex.vue?vue&type=style&index=0&id=8c545a42&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c545a42"]])

export default __exports__